export default __webpack_public_path__ + "static/media/shipper_receiver.e6267b93.png";